import React from 'react'
import { graphql } from 'gatsby'
import FeaturedJob from '../FeaturedJob'
import CTABanner from '../CTABanner'

import { Link } from 'gatsby'
import { Subscribe } from 'unstated'

import './style.scss'
import AppContainer from '../AppContainer/index'

const FooterMenu = ({ menuItems, contactButton }) => {
  return (
    <Subscribe to={[AppContainer]}>
      {appContainer => (
        <nav className="c-footer-menu">
          <ul>
            {menuItems.map(menuItem => (
              <li key={menuItem.link + menuItem.label}>
                <Link to={menuItem.link}>{menuItem.label}</Link>
                {menuItem.subItems && (
                  <ul>
                    {menuItem.subItems.map(subMenuItem => (
                      <li key={subMenuItem.link + subMenuItem.label}>
                        <Link to={subMenuItem.link}>{subMenuItem.label}</Link>
                      </li>
                    ))}
                  </ul>
                )}
              </li>
            ))}
            {contactButton && (
              <li>
                <button onClick={appContainer.openContactModal}>
                  Contact Us
                </button>
              </li>
            )}
          </ul>
        </nav>
      )}
    </Subscribe>
  )
}

const Footer = ({ job, products }) => {
  const today = new Date()

  const mainMenuLinks = [
      { label: 'About Partners in Performance', link: 'https://www.pip.global/' },
      { label: 'Use Cases', link: '/learn' },
       { label: 'Services', link: '/products/services' },

    {
      label: 'Products',
      link: '/products',
      subItems: products.edges.map(product => ({
        label: product.node.frontmatter.title,
        link: product.node.fields.slug,
      })),
    },



  ]

  const secondaryMenuLinks = [
    { label: 'About Us', link: '/about' },
   // { label: 'Jobs', link: '/jobs' },
    { label: 'Contact us', link: '/contact' },
    //    { label: 'Partners', link: '#' },

    //    { label: 'Faq', link: '#' },
    { label: 'Testimonials', link: '/testimonials/' },
    { label: 'Blog', link: '/blog' },
      { label: 'Scientific publications', link: '/papers' },
        { label: 'Applications', link: '/applications' },
  ]
//             <FeaturedJob job={job} />
  return (
    <footer className="c-footer bg-light ">
      <div className="container py-3 py-md-5">
        <div className="row d-block d-md-flex">
          <div className="col-md-3 mb-3">
            <FooterMenu
              products={products}
              menuItems={mainMenuLinks}
              // contactButton
            />
          </div>
          <div className="col-md-3">
            <FooterMenu menuItems={secondaryMenuLinks} />
          </div>
          <div className="col-md-6 pl-5 d-none d-sm-block">

          </div>
        </div>
        <div className="row pt-3">
          <div className="col-12">
            <div className="c-disclaimer">
              <ul>
                <li> © {today.getFullYear()} DataStories part of Accenture</li>
                <li>
                  <a href="/privacy_policy">Privacy Policy</a>
                </li>
                <li>
                  <a href="/terms_conditions">Terms & Conditions</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer

export const ProductFooterQuery = graphql`
  fragment productFooterMenu on Query {
    productFooterSubMenuItems: allMarkdownRemark(
      filter: {
        frontmatter: { type: { eq: "product" }, hideInMenu: { eq: false } }
      }
      sort: { order: ASC, fields: [frontmatter___weight] }
    ) {
      edges {
        node {
          id
          fields {
            slug
          }
          frontmatter {
            title
          }
        }
      }
    }
  }
`
